module.exports = __webpack_public_path__ + "img/swbg.9690bab4.png";